import { sendSignInLinkToEmail, signOut } from "firebase/auth";

export function sendSignInLink(auth, email, actionCodeSettings) {
  return new Promise((resolve) => {
    try {
      sendSignInLinkToEmail(auth, email, actionCodeSettings).then(() => {                
        return resolve({ sendSignInLinkToEmail: true });
      });
    } catch (error) {
      return resolve(error);
    }
  });
}

export function logout(auth) {  
  return new Promise((resolve) => {
    try {
      signOut(auth).then(() => {
        return resolve();
      });
    } catch (error) {
      return resolve(error);
    }
  });
}